import cronJobPayloadSchema from 'root/src/shared/descriptions/endpoints/schemas/requestSchemas/cronJobPayloadSchema';
import { creatorConstants } from 'root/src/shared/creator/creator.constants';
export const initCollectCreatorDataEndpoint = {
    [creatorConstants.INIT_COLLECT_CREATOR_DATA]: {
        payloadSchema: cronJobPayloadSchema,
        isCron: true,
    },
};
